export default "<p>frequent-questions works!</p>\r\n"